/** Hub : 8 cartes, progression, scores (index.html:1877-1897). Clic délégué via data-i. */
import { DIFF_IC, DIFFS, SIZE_NAMES } from '@ordre-cache/shared';
import { GAMES, state } from '../../state';
import { progOf } from '../../storage';
import { gameScore, gameStars } from '../../score';

export function renderHub(): void {
  const sub = document.getElementById('hubSub');
  if (sub) {
    sub.textContent = `${DIFF_IC[state.diff]} ${DIFFS[state.diff]} · ${SIZE_NAMES[state.sizeIdx]}`;
  }
  const grid = document.getElementById('gameGrid');
  if (!grid) return;
  grid.innerHTML = '';
  GAMES.forEach((g, i) => {
    const pr = progOf(g.id, state.diff);
    const card = document.createElement('div');
    card.className = 'gCard';
    card.style.setProperty('--ac', g.accent);
    card.style.setProperty('--i', String(i));
    card.dataset.i = String(i);
    card.innerHTML = `<div class="gCap"></div><div class="gi"><span>${g.icon}</span></div><div class="gn">${g.name}</div>
      <div class="gt">${g.tag}</div>
      <div class="gProg">${pr.map((d) => `<i class="${d ? 'd' : ''}"></i>`).join('')}</div>
      <div class="gScore">★ ${gameStars(g.id, state.diff)}/18 · 🏆 ${gameScore(g.id)} pts</div>`;
    grid.appendChild(card);
  });
}
